export default "__VITE_ASSET__gmE9FjC$__"